var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.52 12.2616C23.52 11.4107 23.4436 10.5925 23.3018 9.80707H12V14.4489H18.4582C18.18 15.9489 17.3345 17.2198 16.0636 18.0707V21.0816H19.9418C22.2109 18.9925 23.52 15.9162 23.52 12.2616Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 23.9945C15.2401 23.9945 17.9565 22.9199 19.9419 21.0872L16.0637 18.0763C14.9892 18.7963 13.6146 19.2217 12.0001 19.2217C8.87463 19.2217 6.22918 17.1108 5.28554 14.2745H1.27645V17.3835C3.251 21.3054 7.30918 23.9945 12.0001 23.9945Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28545 14.2724C5.04545 13.5524 4.90909 12.7833 4.90909 11.9924C4.90909 11.2014 5.04545 10.4324 5.28545 9.71235V6.60326H1.27636C0.463636 8.22326 0 10.056 0 11.9924C0 13.9287 0.463636 15.7614 1.27636 17.3814L5.28545 14.2724Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 4.77273C13.7619 4.77273 15.3437 5.37818 16.5874 6.56727L20.0292 3.12545C17.951 1.18909 15.2346 0 12.0001 0C7.30918 0 3.251 2.68909 1.27645 6.61091L5.28554 9.72C6.22918 6.88364 8.87463 4.77273 12.0001 4.77273Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.1c061267532f4978f4635b9c750fb1e3.svg";
export { ForwardRef as ReactComponent };